import type { PropsWithChildren } from 'react';
import type { LayoutContentProps } from './types';

import './LayoutContent.scss';

export function LayoutContent({ layout = 'default', children }: PropsWithChildren<LayoutContentProps>) {
    return (
        <div data-testid="layout-content" className={`layout-content layout-content--${layout}`}>
            {children}
        </div>
    );
}
